const initialState = {
    acad: null, gpa: null, isLoading: true, isRejected: false, isGpaPredict: false, err: null
}

export default (state = initialState, action) => {
    switch (action.type) {        
        case 'LOAD_ACADEMIC_REG_PENDING':
            return { acad: null, gpa: null, isLoading: true, isRejected: false, isGpaPredict: false,  err: null }
            
        case 'LOAD_ACADEMIC_REG_SUCCESS':
            return { acad: action.payload.acad, gpa: action.payload.gpa, isLoading: false, isRejected: false, isGpaPredict: false, err: null }

        case 'LOAD_ACADEMIC_REG_REJECTED':
            return { acad: null, gpa: null, isLoading: false, isRejected: true, isGpaPredict: false, err: action.payload }

        case 'GPA_PREDICT_PENDING':            
            return { ...state, isGpaPredict: true }
            
        case 'UPDATE_GPA': {
            return { ...state, isGpaPredict: false,
                ...action.payload           
            }  
        }   
        
        case 'UPDATE_GRADE': {
            return {
                ...state,
                acad: state.acad.map(acad => {
                    if (acad.sem === action.payload.sem && 
                        acad.yar === action.payload.yar &&
                        acad.crs === action.payload.crs &&
                        acad.lec === action.payload.lec &&
                        acad.lab === action.payload.lab &&
                        acad.ipt === action.payload.ipt ) {
                        return {
                            ...acad,
                            grd: action.payload.grd
                        }
                    }
                    return acad
                })
            }
        }    
        default:
            return state
    }
}